module.exports = __webpack_public_path__ + "static/media/pillow2x.dbc17418.png";